import React from "react";
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RestoreIcon from "@mui/icons-material/Restore";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import { GetAllFilesAndFoldersByUserDto } from "../../types/FolderPermission";
import {
  GLOBALMESSAGES,
  RECYCLEMESSAGES,
  SINGLE_FILE_EXISTS,
  SINGLE_FOLDER_EXISTS,
} from "../../constants/messages";
import { FolderFileType } from "../../data/Enums";
interface FileFolderExistPopupProps {
  open: boolean;
  onClose: () => void;
  currentRow: GetAllFilesAndFoldersByUserDto;
  handleRestore: (isSkip: boolean, row: GetAllFilesAndFoldersByUserDto) => void;
  fileName: string;
  folderName: string;
  type: string;
}

const FileReplacer: React.FC<FileFolderExistPopupProps> = ({
  open,
  onClose,
  currentRow,
  handleRestore,
  fileName,
  folderName,
  type,
}) => {
  const handleReplace = async () => {
    handleRestore(false, currentRow);
  };

  const handleSkip = async () => {
    handleRestore(true, currentRow);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle id="customized-dialog-title">{RECYCLEMESSAGES.REPLACESKIP_TITLE}</DialogTitle>
      <IconButton
        aria-label={GLOBALMESSAGES.Close}
        onClick={onClose}
        sx={() => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: "#fff",
        })}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent dividers>
        <Typography>
          {type === FolderFileType[FolderFileType.File]
            ? SINGLE_FILE_EXISTS(fileName)
            : SINGLE_FOLDER_EXISTS(folderName)}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box display="flex" flexDirection="column" width="100%">
          <Button
            onClick={handleReplace}
            color="primary"
            startIcon={<RestoreIcon />}
            sx={{
              boxShadow: 1,
              bgcolor: "primary.light",
              color: "white",
              "&:hover": {
                bgcolor: "primary.main",
              },
              mb: 1,
            }}
          >
            {type === FolderFileType[FolderFileType.File]
              ? RECYCLEMESSAGES.FILE_REPLACE
              : RECYCLEMESSAGES.FOLDER_REPLACE}
          </Button>
          <Button onClick={handleSkip} color="secondary" startIcon={<SkipNextIcon />}>
            {type === FolderFileType[FolderFileType.File]
              ? RECYCLEMESSAGES.FILE_SKIP
              : RECYCLEMESSAGES.FOLDER_SKIP}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default FileReplacer;
